import { render } from "./ProjectTeam.vue?vue&type=template&id=3456ee1e&scoped=true"
import script from "./ProjectTeam.vue?vue&type=script&lang=js"
export * from "./ProjectTeam.vue?vue&type=script&lang=js"

import "./ProjectTeam.vue?vue&type=style&index=0&id=3456ee1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3456ee1e"]])

export default __exports__